// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateSearchQueryString = (state, action) => action.query;

const actionTypes = {
    [actions.UPDATE_PART_REQUESTS_SEARCH_QUERY_STRING]: updateSearchQueryString
};

export default (state = getDefaultState().searchQueryString, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/search/reducers/search-query-string.js